<div class="mail-progress-bar" *ngIf="visible">
  <div class="header">
    <span>📧 Sending UPSI Emails ({{ sent }}/{{ total }})</span>
    <button (click)="close()">✖</button>
  </div>

  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progress"></div>
  </div>

 <div class="footer">
  <span class="sent">Sent: {{ sent }}</span>
  <span class="failed">Failed: {{ failed }}</span>
  <span class="pending">Pending: {{ pending }}</span>
</div>

</div>
